/**
 * 完成预览横幅：完成时先显示，让用户欣赏拼好的成品，再点击/自动进入成绩弹层。
 * （背景半透明遮罩突出画板上的拼合结果，烟花在其下透过可见。）
 */
export interface PreviewBanner {
  el: HTMLElement;
  show(): void;
  hide(): void;
}

export function createPreviewBanner(onContinue: () => void): PreviewBanner {
  const el = document.createElement('div');
  el.className = 'pintu-preview';
  el.hidden = true;
  el.innerHTML = `
    <div class="pintu-preview-card" role="status">
      <div class="pintu-preview-title">🎉 拼好了！</div>
      <div class="pintu-preview-sub">欣赏一下你的成果</div>
      <button type="button" data-continue>查看成绩</button>
    </div>
  `;
  el.querySelector<HTMLButtonElement>('[data-continue]')!.addEventListener('click', onContinue);

  return {
    el,
    show() {
      el.hidden = false;
    },
    hide() {
      el.hidden = true;
    },
  };
}
